import type { Step } from '../../types/step';
import { StepCategory } from '../../../types/app_data';
import { getAddMaintenanceReminderSteps } from '../../common/addmaintenance';

const filterFunction = (appData) => {
  // Don't show the prompt if insurance is selected. It will be asked in the onboarding section.
  // If insurance is selected, ask these questions in the onboarding section.
  if (appData.selectedService?.insurance) {
    return false;
  }

  if (appData.signupParams?.needNNOInsurance === true) {
    return false;
  }

  return !!appData.serviceSplitSelectedService?.garage || !!appData.selectedService?.garage;
};

/**
 * Steps for adding maintenance reminders
 */
export const GarageOnlyAddMaintenanceReminderSteps: Step[] = getAddMaintenanceReminderSteps({
  flowCategory: StepCategory.GarageOnlyServices,
  flowFilter: filterFunction,
}).slice(1);

/**
 * Steps for adding maintenance reminders, for car value flow
 */
export const CarValueAddMaintenanceReminderSteps: Step[] = getAddMaintenanceReminderSteps({
  flowCategory: StepCategory.GarageOnlyAccount,
  flowFilter: filterFunction,
}).slice(1);
